"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = __importStar(require("react"));
const material_1 = require("@mui/material");
const Code_1 = __importDefault(require("@mui/icons-material/Code"));
const icons_1 = require("../common/icons");
const SessionBuilderContext_1 = require("../../context/SessionBuilderContext");
const ChatConversation = ({ messages, responseTextAlias, }) => {
    const containerRef = (0, react_1.useRef)(null);
    const { handleAiResponseClick } = (0, SessionBuilderContext_1.useSessionBuilder)();
    (0, react_1.useEffect)(() => {
        if (containerRef.current) {
            containerRef.current.scrollTop = containerRef.current.scrollHeight;
        }
    }, [messages]);
    return ((0, jsx_runtime_1.jsx)(material_1.Box, { ref: containerRef, sx: {
            display: "flex",
            flexDirection: "column",
            gap: 2,
            p: 2,
            // maxHeight: 500,
            // overflowY: 'auto',
        }, children: messages.map((msg) => ((0, jsx_runtime_1.jsxs)(react_1.default.Fragment, { children: [(0, jsx_runtime_1.jsx)(material_1.Box, { sx: { display: "flex", justifyContent: "flex-end", mb: 1 }, children: (0, jsx_runtime_1.jsxs)(material_1.Paper, { sx: {
                            p: 1.5,
                            maxWidth: 350,
                            background: "#e3f2fd",
                            borderRadius: 2,
                            borderTopRightRadius: 0,
                        }, children: [(0, jsx_runtime_1.jsx)(material_1.Typography, { variant: "body2", color: "primary.main", style: { wordBreak: "break-word" }, children: msg.prompt }), (0, jsx_runtime_1.jsxs)(material_1.Box, { sx: {
                                    display: "flex",
                                    alignItems: "center",
                                    justifyContent: "flex-end",
                                    mt: 0.5,
                                }, children: [(0, jsx_runtime_1.jsx)(material_1.Typography, { variant: "caption", color: "text.secondary", sx: { fontSize: 12, mr: 0.5 }, children: new Date().toLocaleTimeString([], {
                                            hour: "2-digit",
                                            minute: "2-digit",
                                        }) }), (0, jsx_runtime_1.jsx)(icons_1.DoubleCheckIcon, { width: 16, height: 16 })] })] }) }), (0, jsx_runtime_1.jsxs)(material_1.Box, { sx: { display: "flex", alignItems: "flex-start", gap: 1, mb: 2 }, children: [(0, jsx_runtime_1.jsx)(material_1.Avatar, { sx: { bgcolor: "primary.main", width: 32, height: 32 }, children: (0, jsx_runtime_1.jsx)(Code_1.default, {}) }), (0, jsx_runtime_1.jsx)(material_1.Paper, { sx: {
                                p: 1.5,
                                maxWidth: 350,
                                background: "#f5f5f5",
                                borderRadius: 2,
                                borderTopLeftRadius: 0,
                                cursor: msg.aiResponseHtml ? "pointer" : "default",
                                opacity: msg.aiResponseHtml ? 1 : 0.7,
                            }, onClick: () => msg.aiResponseHtml &&
                                (handleAiResponseClick === null || handleAiResponseClick === void 0 ? void 0 : handleAiResponseClick(msg.aiResponseHtml)), title: msg.aiResponseHtml
                                ? "Click to load this response in preview"
                                : "", children: msg.isLoading ? ((0, jsx_runtime_1.jsxs)(material_1.Box, { sx: { display: "flex", alignItems: "center", gap: 1 }, children: [(0, jsx_runtime_1.jsx)(material_1.CircularProgress, { size: 18 }), (0, jsx_runtime_1.jsx)(material_1.Typography, { variant: "body2", color: "text.secondary", children: "Generating..." })] })) : msg.aiResponseHtml ? ((0, jsx_runtime_1.jsx)(material_1.Box, { sx: {
                                    border: "1px solid #e0e0e0",
                                    borderRadius: 1,
                                    overflow: "hidden",
                                    background: "white",
                                    mt: 1,
                                }, children: responseTextAlias })) : ((0, jsx_runtime_1.jsx)(material_1.Typography, { variant: "body2", color: "text.secondary", children: "No response yet." })) })] })] }, msg.id))) }));
};
exports.default = ChatConversation;
